import { render, staticRenderFns } from "./mobile-preview.vue?vue&type=template&id=7905c60c&scoped=true"
import script from "./mobile-preview.vue?vue&type=script&lang=ts"
export * from "./mobile-preview.vue?vue&type=script&lang=ts"
import style0 from "./mobile-preview.vue?vue&type=style&index=0&id=7905c60c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7905c60c",
  null
  
)

export default component.exports